var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ticket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.906 11.541l3.551 3.553 6.518-6.518-3.553-3.551-6.516 6.516zM19.104 6.664l-1.511-1.512c-0.289 0.156-0.618 0.246-0.969 0.246-1.118 0-2.024-0.906-2.024-2.023 0-0.352 0.089-0.682 0.246-0.969l-1.511-1.512c-0.394-0.393-1.038-0.393-1.432 0l-11.010 11.010c-0.393 0.392-0.393 1.037 0 1.432l1.512 1.51c0.289-0.156 0.618-0.246 0.97-0.246 1.117 0 2.023 0.906 2.023 2.025 0 0.35-0.089 0.68-0.246 0.969l1.512 1.51c0.394 0.394 1.037 0.394 1.432 0l11.008-11.008c0.394-0.395 0.394-1.039 0-1.432zM8.457 16.719l-5.176-5.178 8.142-8.141 5.176 5.176-8.142 8.143z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.dfe87323832ab2c6eac3414112d966f1.svg";
export { ForwardRef as ReactComponent };